import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';
import { MarkType } from '@entities/Auto';

export const getMarks = createAsyncThunk<MarkType[], undefined>('autoParams/getMarks', async () => {
  return await MyAxios.get('/api/catalog/v1/get-auto-mark').then(handleResponse).catch(handleError);
});
